<template>
    <div>
        <div class="questions-content">
            <h3 class="ml-0 ml-sm-4 d-flex align-items-center">
                <span id="poolLabel" class="flex-grow-1">Pool Settings</span>
                <w-button id="goBack" class="px-4" :to="{name: 'Mypools'}">Back</w-button>
            </h3>
            <w-questions :changed.sync="changed"
                         :button-float="true"
                         :sense-only="senseOnly"
                         class="questions-module"
                         :answers="answers"
                         :sections="sections"
                         :short-title="true"
                         :message-show="message.text"
                         :message-text="message.text"
                         :message-type="message.type"
                         @save="submit"/>
            <w-version/>
        </div>
    </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'
import { lambda } from '../../amplify'

export default {
    name: 'Questions',
    data () {
        return {
            changed: false,
            answers: {
                waterBodyId: this.poolId,
                addr1: '',
                addr2: '',
                city: '',
                state: '',
                zip: ''
            },
            message: {
                text: '',
                type: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            pool: 'pools/pool',
            attributes: 'auth/attributes',
            senseOnly: 'pools/senseOnly'
        }),
        sections () {
            return this.$store.getters['pools/podInstalled'] ? [] : [
                'pool_name',
                'address',
                'gallons',
                'equipment',
                'other_questions'
            ]
        }
    },
    beforeRouteUpdate (to, from, next) {
        if (!this.changed) next()
        else if (confirm('Your changes will be lost. Do you want to continue?')) next()
    },
    beforeRouteLeave (to, from, next) {
        if (!this.changed) next()
        else if (confirm('Your changes will be lost. Do you want to continue?')) next()
    },
    created () {
        if (!this.pool) return
        for (let key in this.pool.waterBody) {
            if (this.pool.waterBody.hasOwnProperty(key)) {
                this.$set(this.answers, key, this.pool.waterBody[key])
            }
        }
        this.$set(this.answers, 'label', this.pool.name)
    },
    mounted () {
        if (this.$route.query.section === 'measurement') {
            const el = document.getElementById('iphonePicker')
            el.click()
        }
    },
    methods: {
        ...mapActions({
            getPools: 'pools/getPools',
            getLabResults: 'pools/getLabResults',
            fetchUser: 'auth/fetchUser'
        }),
        submit (data) {
            this.message.text = ''
            this.message.type = ''
            data.zip = parseInt(data.zip)
            lambda('updateWaterBody', { waterBody: data }).then(data => {
                if (data.code === 'OK') {
                    this.getPools()
                    this.getLabResults()
                    this.fetchUser()
                } else if (data.code === 'WATER_BODY_LABEL_EXISTS') {
                    this.message.text = 'You already have a pool with this name'
                    this.message.type = 'danger'
                }
            })
        }
    },
    watch: {
        pool () {
            if (!this.pool) return
            for (let key in this.pool.waterBody) {
                if (this.pool.waterBody.hasOwnProperty(key)) {
                    this.$set(this.answers, key, this.pool.waterBody[key])
                }
            }
            this.$set(this.answers, 'label', this.pool.name)
        }
    }
}
</script>

<style scoped lang="scss">

    .questions-content {
        max-width: 784px;

        select, select:hover {
            outline: 0 !important;
            -webkit-appearance: none;
        }

        .questions-content h3 {
            padding-left: 15px;
            width: 50%;
        }
    }

    @media (min-width: 576px) {
        .header {
            margin-bottom: 100px;
            margin-right: 50%;
        }

    }

    @media (max-width: 768px) {
        .questions-content {
            h3 {
                padding-right: 15px;
                padding-left: 0;
            }

            .questions-module, .version {
                margin-left: -18px;
                padding-left: 17px;
                padding-right: 17px;
            }
        }
    }
</style>
